<template>
  <v-card :loading="loading" class="havet-card" elevation="2">
    <div class="top-row pa-3">
      <h4>{{ label }}</h4>
    </div>
    <div class="list mt-2">
      <div class="list-item bold">
        <div>Status</div>
        <div>Sidnamn</div>
        <div>Typ</div>
        <div>Nyckelord</div>
        <div>Skapad</div>
        <div>Uppdaterad</div>
        <div>Uppdaterd av</div>
      </div>
      <LatestPagesListItemHavsutsikt v-for="item in items" v-bind="item" :key="item.id" @click="onClickRow" />
    </div>
  </v-card>
</template>

<script>
import LatestPagesListItemHavsutsikt from './LatestPagesListItemHavsutsikt'

export default {
  name: 'LatestPages',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    items: {
      type: [Array, Object],
    },
    label: {
      type: String,
      default: 'Senaste sidorna',
    },
  },
  components: {
    LatestPagesListItemHavsutsikt,
  },
  computed: {},
  methods: {
    onClickRow(id) {
      this.$emit('page:goto', { id })
    },
  },
}
</script>

<style lang="less" scoped>
.havet-card {
  width: 100%;
  max-width: 100%;
  .list {
    font-size: 0.9rem;
    overflow: auto;
    max-height: 100%;
    .list-item {
      display: grid;
      grid-template-columns: 75px 1fr 120px 120px 120px 120px 140px;
      grid-template-rows: 1fr;
      grid-column-gap: 10px;
      grid-row-gap: 0px;

      padding: 6px 10px;
      border-bottom: #ccc 1px solid;
      background-color: #fff;
    }
    .bold {
      font-weight: 500;
    }
  }
}
</style>
